module.exports = __webpack_public_path__ + "img/tripadvisor-logo.7e22b422.png";